import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./About.css";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";

export default class About extends Component {
  render() {
    return (
      <div>
        <div className="home">
          <section className="hero">
            <h1 className="hero-text">
              <span className="highlight">Empowering Businesses</span> through <br />
              Innovation, Strategy & Tech
            </h1>
            <p className="subtext">
              At Ambrum, we transform ambitious ideas into digital realities <br />
              blending smart software solutions with impactful marketing to shape the future of business.
            </p>
            <Link to="/talk-to-us" className="cta-link">
              Book a free consultation ›
            </Link>
          </section>

          <section className="metrics">
            <div className="metric"><span className="number">4+</span> Years of Operation</div>
            <div className="metric"><span className="number">50+</span> World-wide Clients</div>
            <div className="metric"><span className="number">100+</span> Successful Projects</div>
            <div className="metric"><span className="number">50+</span> Employees</div>
          </section>

          <section className="story">
            <h2>The Ambrum Story</h2>
            <p>
              Ambrum was born from a shared vision. to bridge the gap between innovation and real-world impact.
              What began as a small team of tech enthusiasts and creative marketers has evolved into a powerhouse
              of digital transformation. We started with a simple belief: businesses, no matter their size,
              deserve access to cutting-edge technology and strategy to thrive in a rapidly changing world.
              From launching healthcare platforms and EV charging systems to redefining brands and driving
              digital campaigns, our journey has been one of continuous growth, purpose, and passion.
            </p>
            <p>
              Today, Ambrum stands as a trusted partner for startups, enterprises, and governments, helping them
              dream bigger, digitize smarter, and deliver more.
            </p>
          </section>

          <section className="services">
            <h2>What We Do Best</h2>
            <div className="service-grid">
              <div className="service">
                <img src="./assets/images/smart-house.gif" alt="Smart Tech" />
                <p>Smart Tech Solutions</p>
              </div>
              <div className="service">
                <img src="./assets/images/innovation.gif" alt="Sustainable Innovation" />
                <p>Sustainable Innovation</p>
              </div>
              <div className="service">
                <img src="./assets/images/advertising.gif" alt="Digital Marketing Mastery" />
                <p>Digital Marketing Mastery</p>
              </div>
              <div className="service">
                <img src="./assets/images/strategy.gif" alt="Business Focused Strategy" />
                <p>Business Focused Strategy</p>
              </div>
            </div>
          </section>

          <div className="section-divider" />




          {/* Vision & Mission */}
          <div className="vision-mission">
            <div className="vm-block">
              <h3 className="vm-title">Vision</h3>
              <p>To become the most trusted digital transformation partner for brands that dare to innovate.</p>
            </div>
            <div className="vm-block">
              <h3 className="vm-title">Mission</h3>
              <p>To empower businesses with tech-driven solutions and strategic creativity to deliver measurable impact, delight customers, and shape tomorrow’s industries.</p>
            </div>
          </div>

          {/* Why Choose Ambrum */}
          <section className="why-choose">
            <h2>Why Choose Ambrum</h2>
            <div className="reasons">
              <div className="reason">
                <img src="./assets/images/multitasking.gif" alt="Smart expertise" />
                <p>Proven expertise in smart cities, e-health, EV, and event tech</p>
              </div>
              <div className="reason">
                <img src="./assets/images/team.gif" alt="Team strength" />
                <p>A passionate team of tech engineers, marketers & strategists</p>
              </div>
              <div className="reason">
                <img src="./assets/images/idea.gif" alt="Agility" />
                <p>Agile, transparent, and fully customizable solutions</p>
              </div>
              <div className="reason">
                <img src="./assets/images/growth.gif" alt="Results" />
                <p>Results-driven with a focus on impact and business growth</p>
              </div>
              <div className="reason">
                <img src="./assets/images/shield.gif" alt="Trusted" />
                <p>Trusted by startups, corporations, and government projects</p>
              </div>
            </div>
          </section>

          {/* Team Section */}
          <section className="team">
            <h2>Meet the Minds Behind Ambrum</h2>
            <div className="team-grid">
              <div className="team-card red-bg">
                <img src="./assets/people/suranga.png" alt="John - CEO" />
              </div>
              <div className="team-card red-bg">
                <img src="./assets/people/leelanga.png" alt="Sara - CTO" />
              </div>
              <div className="team-card red-bg">
                <img src="./assets/people/tharaka.png" alt="Sara - CTO" />
              </div>
              <div className="team-card red-bg">
                <img src="./assets/people/tharindu.png" alt="Sara - CTO" />
              </div>
              <div className="team-card red-bg">
                <img src="./assets/people/farshad.png" alt="Mark - Marketing" />
              </div>
            </div>
          </section>


          {/* Culture & Values */}
          <section className="culture">
            <h2>Our Culture & Values</h2>
            <div className="culture-grid">
              <div className="culture-item">
                <img src="./assets/images/inno.gif" alt="Innovation" />
                <p>Innovation</p>
              </div>
              <div className="culture-item">
                <img src="./assets/images/creativity.gif" alt="Creativity" />
                <p>Creativity</p>
              </div>
              <div className="culture-item">
                <img src="./assets/images/coexistence.gif" alt="Collaboration" />
                <p>Collaboration</p>
              </div>
              <div className="culture-item">
                <img src="./assets/images/economy.gif" alt="Growth" />
                <p>Growth</p>
              </div>
            </div>
          </section>

          <ContactUsFooter />
        </div>
        <Footer />
      </div>

    );
  }
}
